module.exports = __webpack_public_path__ + "static/media/specialty-resort.4f757b05.svg";